/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CustomerWalletInvoiceTopupPathParams,
	CustomerWalletInvoiceTopupRequest,
	CustomerWalletInvoiceTopupResponse,
} from '../types/CustomerWalletInvoiceTopup'

/**
 * POST /:organisation/wallet/invoice-topup
 * @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::invoiceTopup
 */
export async function customerWalletInvoiceTopup(
	organisation: CustomerWalletInvoiceTopupPathParams['organisation'],
	data: CustomerWalletInvoiceTopupRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomerWalletInvoiceTopupResponse>> {
	return axiosInstance.post(`/${organisation}/wallet/invoice-topup`, data, config)
}
